document.addEventListener('DOMContentLoaded', function() {
    const productBlocks = document.querySelectorAll('.aec-products__content');

    productBlocks.forEach(block => {
        const tabsNav = block.querySelector('.aec-products__nav');
        const tabItems = block.querySelectorAll('.aec-products__item');
        const tabContents = document.querySelectorAll(`.aec-products__wrapper[data-container="${block.dataset.blockId}"]`);

        if (!tabItems.length || !tabContents.length || !tabsNav) return;

        // Get total tabs count
        const totalTabs = tabItems.length;

        // Hide tab navigation if there's only 1 tab
        if (totalTabs <= 1) {
            tabsNav.style.display = 'none';
            return;
        }

        // Check if horizontal scroll is needed:
        // - If there are more than 5 tabs OR
        // - If tab names are too big to fit in the container
        const requiresHorizontalScroll = () => {
            return totalTabs > 5 || tabsNav.scrollWidth > tabsNav.offsetWidth;
        };

        if (requiresHorizontalScroll()) {
            // Add horizontal scroll with mouse wheel
            tabsNav.addEventListener('wheel', (e) => {
                e.preventDefault(); // Prevent vertical page scrolling
                tabsNav.scrollLeft += e.deltaY; // Scroll left/right based on wheel direction
            });

            // Add class for scroll styling
            tabsNav.classList.add('scrollable');
        }

        // Tab switching logic
        tabItems.forEach((item) => {
            item.addEventListener('click', () => {
                tabItems.forEach((tabItem) => {
                    tabItem.classList.remove('active-tab');
                });
                item.classList.add('active-tab');

                const tabValue = item.getAttribute('data-value');

                tabContents.forEach((content) => {
                    content.style.display = 'none';
                });

                const activeContent = document.querySelector(
                    `.aec-products__wrapper[data-container="${block.dataset.blockId}"].${tabValue}`
                );

                if (activeContent) {
                    activeContent.style.display = 'flex';
                }
            });
        });

        // Activate the first tab by default
        if (tabItems.length > 0) {
            tabItems[0].click();
        }
    });

    // Function to initialize both tab switching and scrolling for dynamically added blocks
    window.initProductTabs = function(newBlock) {
        if (!newBlock) return;

        const tabsNav = newBlock.querySelector('.aec-products__nav');
        const tabItems = newBlock.querySelectorAll('.aec-products__item');
        const tabContents = document.querySelectorAll(`.aec-products__wrapper[data-container="${newBlock.dataset.blockId}"]`);

        if (!tabItems.length || !tabContents.length || !tabsNav) return;

        // Get total tabs count
        const totalTabs = tabItems.length;

        // Hide tab navigation if there's only 1 tab
        if (totalTabs <= 1) {
            tabsNav.style.display = 'none';
            return;
        }

        // Check if horizontal scroll is needed
        const requiresHorizontalScroll = () => {
            return totalTabs > 5 || tabsNav.scrollWidth > tabsNav.offsetWidth;
        };

        if (requiresHorizontalScroll()) {
            // Add horizontal scroll with mouse wheel
            tabsNav.addEventListener('wheel', (e) => {
                e.preventDefault();
                tabsNav.scrollLeft += e.deltaY;
            });

            // Add class for scroll styling
            tabsNav.classList.add('scrollable');
        }

        // Tab switching logic
        tabItems.forEach((item) => {
            item.addEventListener('click', () => {
                tabItems.forEach((tabItem) => {
                    tabItem.classList.remove('active-tab');
                });
                item.classList.add('active-tab');

                const tabValue = item.getAttribute('data-value');
                tabContents.forEach((content) => {
                    content.style.display = 'none';
                });

                const activeContent = document.querySelector(
                    `.aec-products__wrapper[data-container="${newBlock.dataset.blockId}"].${tabValue}`
                );

                if (activeContent) {
                    activeContent.style.display = 'flex';
                }
            });
        });

        // Activate the first tab by default
        if (tabItems.length > 0) {
            tabItems[0].click();
        }
    };
});